import "./styles/main.css";
import "./styles/player.css";
import "./styles/autocomplete.css";
import "./styles/select.css";
import "./styles/datepicker.css";
import "./styles/timepicker.css";
import "./styles/pickerwrapper.css";
import "./styles/newdevice.css";
import "./styles/elevation.css";

import "./styles/user-page.css";
import "./styles/material.css";

import "./js/app";
import "./js/fabric";
import "./js/browser";
import registerServiceWorker from "./js/registerServiceWorker";

import "material-components-web-elm/dist/material-components-web-elm.js";
import "material-components-web-elm/dist/material-components-web-elm.css";

registerServiceWorker();
